import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { JwtModule } from '@auth0/angular-jwt';
import { MarkdownModule } from 'angular2-markdown/markdown';
import { DashboardModule } from 'app/dashboard/dashboard.module';
import { LoginModule } from 'app/login/login.module';
import { ResourceModule } from 'ngx-resource';

import { AnnouncementsModule } from './announcements/announcements.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { ChatsModule } from './chats/chats.module';
import { ConfigurationsModule } from './configurations/configurations.module';
import { FeedbacksModule } from './feedbacks/feedbacks.module';
import { NotificationsModule } from './notifications/notifications.module';
import { AuthGuard } from './shared/auth/auth.guard';
import { AuthService } from './shared/auth/auth.service';
import { EventsBusService } from './shared/eventsBus.service';
import { SharedModule } from './shared/shared.module';

export function tokenGetter() {
  return localStorage.getItem('id_token');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    LoginModule,
    AnnouncementsModule,
    DashboardModule,
    FeedbacksModule,
    ChatsModule,
    ConfigurationsModule,
    NotificationsModule,
    SharedModule.forRoot(),
    ResourceModule.forRoot(),
    MarkdownModule.forRoot(),
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: [
          'localhost:3000',
          'api.notis.vn',
          'api.notis.dev',
          'api.notis.local',
          'api.mytrans.notis.vn',
          'api.mytrans.notis.local',
          'ttgt.vn',
          'mytrans.local',
          '10.86.62.201:8080',
          'api.mytrans.ttgt.dev',
          'api.dongnai.ttgt.vn',
        ],
      },
    }),
  ],
  providers: [
    EventsBusService,
    // AUTH_PROVIDERS,
    AuthService,
    AuthGuard,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /ng-app/src/app/app.module.ts